export default "__VITE_ASSET__4832e32d__"